module.exports = __webpack_public_path__ + "img/4.dd723eae.png";